<template>
  <div class="box box--project">
    <div class="box-inner">
      <router-link :to="`/projects/${box.idProject}`" class="box-title">{{box.name}}</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "BoxProject",
  props: ['box'],
}
</script>
